/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

const axios = require("axios")

class ApiService {
  registered = false
  incrementLoading = undefined
  history = undefined
  decrementLoading = undefined

  register = ({ history, incrementLoading, decrementLoading }) => {
    this.registered = true
    this.incrementLoading = incrementLoading
    this.decrementLoading = decrementLoading
    this.history = history
  }

  get = async (url) => {
    this.checkRegister()
  }

  post = async (url, data, headers) => {
    this.checkRegister()
    this.incrementLoading()
    try {

      const res = await axios.post(url, data, {
        headers:{
          'opl':data.tunnelData.opl,
          'step':data.tunnelData.step
        }
      })
      return res.data
    } catch (error) {
      console.error("Voyager error : ", error)
      return error
    } finally {
      this.decrementLoading()
    }
  }

  postForEvollisApi = async (url, data, headers) => {
    try {

      const res = await axios.post(url, data, headers)
      return res.data
    } catch (error) {
      console.error("Voyager error", error)
      throw error
    }
  }


  logEventWithScript = async (message,data) => {
    try {
      const url = "/api/v1/send-log-notification";
      const res = await axios.post(url, {"message":message}, {
        headers:{
          'opl':data.opl,
          'step':data.step
        }
      })
      return res.data
    } catch (error) {
      console.error("Voyager error", error)
      throw error
    }
  }

  getForEvollisApi = async (url, headers) => {
    try {
      let response = await axios.get(url, { headers: headers })
      return response.data
    } catch (error) {
      console.error("Voyager error", error)
      throw error
    }
  }

  checkRegister = () => {
    if (!this.registered) {
      console.error("ApiService not registered")
    }
  }
}

export default new ApiService()
